import { createTheme } from '@mui/material';
import { red } from '@mui/material/colors'; // Example color

export const fontFamily = 'Poppins';

// Light Theme Definition
export const lightTheme = createTheme({
  palette: {
    mode: 'light', // Important: sets the mode to light
    primary: {
      main: '#023059', // Your primary color, e.g., the header blue
    },
    secondary: {
      main: '#19857b', // An example secondary color
    },
    error: {
      main: red.A400, // An example error color
    },
    background: {
      default: '#ffffff', // Default background for light mode
      paper: '#f5f5f5', // Background for paper-like elements (cards, etc.)
    },
    text: {
      primary: '#111111',
      secondary: '#555555',
    },
    svgIcons: {
      primary: {
        fill: '#1049E5',
      },
      error: {
        fill: '#A03434',
      },
    },
  },
  // You can also customize typography, spacing, components defaults, etc.
  typography: {
    fontFamily,
  },
});

// Dark Theme Definition
export const darkTheme = createTheme({
  palette: {
    mode: 'dark', // Important: sets the mode to dark
    primary: {
      main: '#023059', // Your primary color, can be the same or adjusted for dark mode
    },
    secondary: {
      main: '#63B3ED', // An example secondary color for dark mode
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#111728', // Default background for dark mode (matches your grid's base)
      paper: '#1C2331', // Background for paper-like elements in dark mode (matches your grid's even rows)
    },
    text: {
      primary: '#E2E8F0', // Light text for dark backgrounds
      secondary: '#A0AEC0', // Dimmer text
    },
    svgIcons: {
      primary: {
        fill: '#1049E5',
      },
      error: {
        fill: '#A03434',
      },
    },
  },
  typography: {
    fontFamily,
  },

  // You can override component styles globally for dark mode here if needed
  components: {},
});
export const myVar = '';
